import "bootstrap/dist/css/bootstrap.css";
import "./Assets/styles/styles.scss";
import "./Assets/styles/media.scss";
import "mapbox-gl/dist/mapbox-gl.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ProtectedRoute, PublicRoute } from "./pages/routeConfig/routeConfig";
import {
  ForgotPasswordPage,
  LoginPage,
  OtpVerificationPage,
  ResetPasswordPage,
  SignupPage,
  SuccessfullStepPage,
  ThankYouPage,
} from "./pages/authRoutes";
import { DashboardPage, UnitDetailPage } from "./pages/rootRoutes";
import { AuthProvider } from "./contexts/authContext";

const App = () => {
  const publicRoutes = [
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/signup",
      element: <SignupPage />,
    },
    {
      path: "/forgot-password",
      element: <ForgotPasswordPage />,
    },
    {
      path: "/otp-verification",
      element: <OtpVerificationPage />,
    },
    {
      path: "/reset-password",
      element: <ResetPasswordPage />,
    },
    {
      path: "/success",
      element: <SuccessfullStepPage />,
    },
    {
      path: "/thank-you",
      element: <ThankYouPage />,
    }
  ];

  const protectedRoutes = [
    {
      path: "/",
      element: <DashboardPage />,
    },
    {
      path: "/unit-details/:id",
      element: <UnitDetailPage />,
    },
  ];

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            {publicRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={<PublicRoute>{route.element}</PublicRoute>}
              />
            ))}

            {/* Protected Routes */}
            {protectedRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={<ProtectedRoute>{route.element}</ProtectedRoute>}
              />
            ))}
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
